<template>
  <div>
    <div id="google_translate_element" style="display:none"></div>

    <div class="container-fluid">
      <div class=" langs-container">
        <img class="lang" data-lang="English" src="/icons/flags/EN.svg" />
        <img class="lang" data-lang="Spanish" src="/icons/flags/ES.svg" />
        <img class="lang" data-lang="Portuguese" src="/icons/flags/PT.svg" />
        <img class="lang" data-lang="Italian" src="/icons/flags/IT.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "google-translate",
  created() {},
  beforeMount() {
    this.googleTranslateElement();
    this.googleInit();
    this.langSelector();
  },
  methods: {
    googleTranslateElement() {
      let googleScript = document.createElement("script");
      googleScript.setAttribute(
        "src",
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
      );
      document.body.appendChild(googleScript);
    },
    googleInit() {
      let googleInit = document.createElement("script");
      googleInit.setAttribute("src", "/js/googleInitialize.js");
      document.body.appendChild(googleInit);
    },
    langSelector() {
      let langSelect = document.createElement("script");
      langSelect.setAttribute("src", "/js/langSelector.js");
      document.body.appendChild(langSelect);
    }
  }
};
</script>

<style>
/*GOOGLE TRANSLATE ELEMENTS HIDER */

div#goog-gt-tt {
  display: none !important;
}
.goog-tooltip {
  display: none !important;
}
.goog-tooltip:hover {
  display: none !important;
}
.goog-text-highlight {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
#goog-gt-tt,
.goog-te-balloon-frame {
  display: none !important;
}
.goog-text-highlight {
  background: none !important;
  box-shadow: none !important;
}
body {
  top: 0 !important;
}
.goog-te-banner-frame {
  display: none !important;
}

/*CUSTOM CSS */
.lang {
  width: 25px;
  margin-right: 3rem;
}
.langs-container {
  display: flex;
  justify-content: space-between;
}
.lang:hover {
  cursor: pointer;
}
img {
  align-self: center !important;
}
</style>
